import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=334c8621"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Header.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml&locale=ru"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('334c8621', component.options)
    } else {
      api.reload('334c8621', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=334c8621", function () {
      api.rerender('334c8621', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/components/Header.vue"
export default component.exports